export type MillConstants = {
  kerf_mm: number;
  edge_trim_mm: number;
  weld_allowance_mm: number;
  tube_weight_factor: number;
  ctl_blade_mm: number;
  ctl_yield_margin_pct: number;
  skinpass_weight_factor: number;
};

export const DEFAULT_MILL_CONSTANTS: MillConstants = {
  kerf_mm: 3,
  edge_trim_mm: 10,
  weld_allowance_mm: 1,
  tube_weight_factor: 0.0246615,
  ctl_blade_mm: 3,
  ctl_yield_margin_pct: 5,
  skinpass_weight_factor: 0.999,
};

export function millConstantsFromCompany(company: {
  mill_kerf_mm?: number | null;
  mill_edge_trim_mm?: number | null;
  mill_weld_allowance_mm?: number | null;
  mill_tube_weight_factor?: number | null;
  mill_ctl_blade_mm?: number | null;
  mill_ctl_yield_margin_pct?: number | null;
  mill_skinpass_weight_factor?: number | null;
} | null | undefined): MillConstants {
  if (!company) return { ...DEFAULT_MILL_CONSTANTS };
  return {
    kerf_mm: Number(company.mill_kerf_mm ?? DEFAULT_MILL_CONSTANTS.kerf_mm),
    edge_trim_mm: Number(company.mill_edge_trim_mm ?? DEFAULT_MILL_CONSTANTS.edge_trim_mm),
    weld_allowance_mm: Number(
      company.mill_weld_allowance_mm ?? DEFAULT_MILL_CONSTANTS.weld_allowance_mm,
    ),
    tube_weight_factor: Number(
      company.mill_tube_weight_factor ?? DEFAULT_MILL_CONSTANTS.tube_weight_factor,
    ),
    ctl_blade_mm: Number(company.mill_ctl_blade_mm ?? DEFAULT_MILL_CONSTANTS.ctl_blade_mm),
    ctl_yield_margin_pct: Number(
      company.mill_ctl_yield_margin_pct ?? DEFAULT_MILL_CONSTANTS.ctl_yield_margin_pct,
    ),
    skinpass_weight_factor: Number(
      company.mill_skinpass_weight_factor ?? DEFAULT_MILL_CONSTANTS.skinpass_weight_factor,
    ),
  };
}
